import React from 'react';
import { colors } from '../../../styles/variables/colors';
import { H2, H5, StyledPageContainer } from '../../../components/styles';
import { ReactComponent as AcceptedIcon } from 'assets/icons/accepted.svg';
import { ReactComponent as RejectedIcon } from 'assets/icons/rejected.svg';
import { VoteResult } from '../../../config/variables';
import { Hero } from '../../../components/Hero';
import styled from '@emotion/styled';

interface DetailHeaderProps {
  subject: string;
  result: VoteResult | null;
  yesVotes: number;
  noVotes: number;
  meeting: string;
  poll: number;
  date: Date | null;
}

const StyledParagraph = styled.p`
  margin: 0.5rem 0;
`;

export const DetailHeader: React.FC<DetailHeaderProps> = (props) => {
  const { subject, result, yesVotes, noVotes } = props;
  const { meeting, poll, date } = props;

  const resultData =
    result === VoteResult.Accepted
      ? { text: 'Přijato', color: colors.green, icon: AcceptedIcon }
      : { text: 'Nepřijato', color: colors.red, icon: RejectedIcon };

  const ResultIcon = resultData.icon;

  return (
    <Hero>
      <StyledPageContainer>
        <H2>Detail hlasování</H2>
        <H5>{subject}</H5>
        {result !== null && (
          <div
            style={{
              display: 'flex',
              marginTop: 16.6,
              alignItems: 'center',
              marginBottom: 16.6,
            }}
          >
            <ResultIcon width={20} />
            <H5
              style={{ color: resultData.color, marginTop: 0, marginLeft: 7 }}
            >
              {resultData.text}
            </H5>
            <div style={{ fontSize: 14, marginLeft: 20 }}>
              Pro:{' '}
              <span style={{ color: colors.green, fontWeight: 'bold' }}>
                {yesVotes}
              </span>
              <span style={{ marginLeft: 6, marginRight: 6 }}>|</span>
              Proti:{' '}
              <span style={{ color: colors.red, fontWeight: 'bold' }}>
                {noVotes}
              </span>
            </div>
          </div>
        )}
        <div>
          <StyledParagraph>
            <strong>Číslo schůze: </strong>
            {meeting}
          </StyledParagraph>
          <StyledParagraph>
            <strong>Číslo hlasování: </strong>
            {poll}
          </StyledParagraph>
          <StyledParagraph>
            <strong>Datum a čas: </strong>
            {date?.toLocaleString()}
          </StyledParagraph>
        </div>
      </StyledPageContainer>
    </Hero>
  );
};
